// 9fbef606107a605d69c0edbcd8029e5d
import { withRouter } from 'next/router';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import CustomerHelpCommonContainer from './CustomerHelpCommon.container';
import customerHelpSaga from './CustomerHelp.saga';

const withSaga = withDynamicSaga({ key: 'CustomerHelpSaga', saga: customerHelpSaga });
const CustomerHelpWithRouter = withSaga(CustomerHelpCommonContainer);
export default withRouter(CustomerHelpWithRouter);
